import { FreelancerProposalDocument } from "./FreelancerProposalDocument";
import { FreelancerProposalStatus } from "./ProposalWorkflow";

// Re-export for backward compatibility
export { FreelancerProposalStatus } from "./ProposalWorkflow";

export enum FreelancerProposalPricingType {
  Daily = "Daily",
  Hourly = "Hourly"
}

export enum FreelancerProposalExpenseNature {
  Accommodation = "Accommodation",
  Catering = "Catering",
  Transport = "Transport",
  Equipment = "Equipment",
  Communication = "Communication",
  Other = "Other"
}

export interface FreelancerProposalTaskStep {
  id?: string;
  title: string;
  description: string;
  days?: number;
  hours?: number;
  dailyRate?: number;
  hourlyRate?: number;
  totalAmount: number;
}

export interface FreelancerProposalExternalCost {
  id?: string;
  description: string;
  amount: number;
}

export interface FreelancerProposalExpense {
  id?: string;
  nature: FreelancerProposalExpenseNature;
  description: string;
  amount: number;
}

// Backend request structures
export interface CreateFreelancerProposalTaskRequest {
  id?: number; // Optionnel - si présent, mise à jour de l'existant
  description: string;
  quantity: number;
  unitPrice: number;
  orderIndex: number;
}

export interface CreateFreelancerProposalExternalCostRequest {
  id?: number; // Optionnel - si présent, mise à jour de l'existant
  description: string;
  estimatedBudget: number;
}

export interface CreateFreelancerProposalExpenseRequest {
  id?: number; // Optionnel - si présent, mise à jour de l'existant
  nature: FreelancerProposalExpenseNature;
  description: string;
  estimatedBudget: number;
}

// Response from API (matches backend FreelancerProposalResponse)
export interface FreelancerProposal {
  id: number;
  projectId: number;
  freelancerProfileId: number;
  relevantExperience: string;
  projectStrengths: string;
  estimatedStartDate: Date;
  comments?: string;
  pricingMode: FreelancerProposalPricingType;
  status: FreelancerProposalStatus;
  totalBudget: number;
  totalExternalCosts: number;
  totalExpenses: number;
  createdAt: Date;
  updatedAt?: Date;
  createdById: number;
  lastModifiedById?: number;
  pennylaneQuoteId?: string;
  tasks: FreelancerProposalTaskResponse[];
  externalCosts: FreelancerProposalExternalCostResponse[];
  expenses: FreelancerProposalExpenseResponse[];
  documents?: FreelancerProposalDocument[];
}

// API response for tasks
export interface FreelancerProposalTaskResponse {
  id: number;
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
  orderIndex: number;
}

// API response for external costs
export interface FreelancerProposalExternalCostResponse {
  id: number;
  description: string;
  estimatedBudget: number;
}

// API response for expenses
export interface FreelancerProposalExpenseResponse {
  id: number;
  nature: FreelancerProposalExpenseNature;
  description: string;
  estimatedBudget: number;
}

export interface CreateFreelancerProposalRequest {
  projectId: number;
  freelancerProfileId: number;
  status: FreelancerProposalStatus; // NotSubmitted = draft, SubmittedCSM = final submission
  relevantExperience: string;
  projectStrengths: string;
  estimatedStartDate: Date;
  comments?: string;
  pricingMode: FreelancerProposalPricingType;
  tasks: CreateFreelancerProposalTaskRequest[];
  externalCosts?: CreateFreelancerProposalExternalCostRequest[];
  expenses?: CreateFreelancerProposalExpenseRequest[];
  hasExternalCosts: boolean;
  hasExpenses: boolean;
}